import { ConcreteNotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import ConcreteNotificationsProvider, {
  useConcreteNotificationsContext,
} from './ConcreteNotificationsContext'
import { useEditFn } from './hooks/useEdit'
import ViewConcreteNotificationEvent from './components/ViewConcreteNotificationEvent'

const InnerNotifications: React.FC = () => {
  const { refetch, fetching } = useConcreteNotificationsContext()
  const editFn = useEditFn()
  return (
    <CIMSNotifications
      onReload={refetch}
      loading={fetching}
      events={ConcreteNotificationEvent.values}
      view={<ViewConcreteNotificationEvent />}
      edit={editFn}
    />
  )
}

const Notifications: React.FC = () => (
  <RecipientsSelectProvider>
    <ConcreteNotificationsProvider>
      <InnerNotifications />
    </ConcreteNotificationsProvider>
  </RecipientsSelectProvider>
)

export default Notifications
